import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import {
  AddEventFileFailure,
  AddEventFileRequest,
  AddEventFileSuccess,
  CreateEventFailure,
  CreateEventRequest,
  CreateEventSuccess,
  DeleteEventFailure,
  DeleteEventRequest,
  DeleteEventSuccess,
  EditEventFailure,
  EditEventRequest,
  EditEventSuccess,
  EEventsChangesActions,
  SetLinkLoadingShow,
  SetMaterialLoadingShow,
} from '@myStore/events-changes/events-changes.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EventsChangesService } from '@services/events-changes/events-changes.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GetEventSuccess } from '@myStore/events-view/events-view.actions';

@Injectable()
export class EventsChangesEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _eventsChangesService: EventsChangesService,
    private _toastr: ToastrService,
    private _router: Router
  ) {}

  $create = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateEventRequest>(EEventsChangesActions.CreateEventRequest),
        switchMap(action => {
          return this._eventsChangesService.create(action.event).pipe(
            map(response => {
              this._toastr.success(response.detail);
              this._store.dispatch(new CreateEventSuccess());
              this._router.navigate([`events/${response.id}`]);
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При создании события возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new CreateEventFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $edit = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditEventRequest>(EEventsChangesActions.EditEventRequest),
        switchMap(action => {
          return this._eventsChangesService
            .edit(action.id, action.payload)
            .pipe(
              map(response => {
                this._toastr.success(`Событие успешно отредактировано`);
                this._store.dispatch(new EditEventSuccess());
                this._store.dispatch(new GetEventSuccess(response));
                this._store.dispatch(new SetMaterialLoadingShow(false));
                this._store.dispatch(new SetLinkLoadingShow(false));
              }),
              catchError(e => {
                this._toastr.error(
                  `${
                    e?.error?.detail
                      ? e?.error?.detail
                      : 'При редактировании события возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new EditEventFailure(e.error));
                this._store.dispatch(new SetMaterialLoadingShow(false));
                this._store.dispatch(new SetLinkLoadingShow(false));
                return e;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $delete = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteEventRequest>(EEventsChangesActions.DeleteEventRequest),
        map(action => action),
        switchMap(action => {
          return this._eventsChangesService.delete(action.event).pipe(
            map(response => {
              this._toastr.success(response.detail);
              this._router.navigate([
                `/courses-and-groups/groups/${action.event.group?.id}/detail/events`,
              ]);
              this._store.dispatch(new DeleteEventSuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При удалении события возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new DeleteEventFailure(err));
              this._toastr.error(err.error[0]);
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $addFile = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddEventFileRequest>(EEventsChangesActions.AddEventFileRequest),
        map(action => action),
        switchMap(action => {
          return this._eventsChangesService.addFile(action.data).pipe(
            map(file => {
              this._store.dispatch(
                new GetEventSuccess({
                  files: [{ id: file.id, file: file.file, name: file.name }],
                  newFile: true,
                })
              );

              this._store.dispatch(new AddEventFileSuccess());
              this._toastr.success('Файл успешно добавлен');
            }),
            catchError(err => {
              this._toastr.error(err.error.file[0]);
              this._store.dispatch(new AddEventFileFailure(err));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
